(function () {
  'use strict';

  angular.module('app').component('accountsPage', accountListComponent());

  function accountListComponent() {
    return {
      bindings: {},
      controller: AccountListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/admin/accounts/accounts-page.component.html',
    };
  }

  AccountListCtrl.$inject = ['$location', 'AccountService'];

  function AccountListCtrl($location, AccountService) {
    var vm = this;

    // Methods
    vm.createItem = createItem;
    vm.onShowItem = onShowItem;

    // Initializers
    getItems();

    function getItems() {
      vm.loadingItems = true;
      AccountService.getAccounts().then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function createItem() {
      $location.path('/accounts/new');
    }

    function onShowItem(item, mode) {
      $location.path(`/accounts/${item.id}`).search({ mode: mode });
    }
  }
})();
